<template>
  <div class="promo-shell video-shell">
    <VideoForm />
    <VideoResult />
  </div>
</template>

<script setup>
import VideoForm from '@/components/promo-video/VideoForm.vue'
import VideoResult from '@/components/promo-video/VideoResult.vue'
</script>
